module.exports = __webpack_public_path__ + "img/ceo-image.87797623.png";